export const PASSWORD_RESET = `mutation PasswordReset($input: PasswordResetMutationInput!) {
    passwordReset(input: $input) {
        success
    }
}`;
